export default "__VITE_PUBLIC_ASSET__d8159575__"